class Node {
    id = "0";
    type = ''; // [paragrapher, category, realisation, contact]
    title = '';
    titleBody = '';
    body = '';
    meta = null;

    constructor(id, type, title) {
        this.id = id;
        this.type = type;
        this.title = title;
    }
}

export default Node;